import { useMemo } from "react"

import { TraceabilityResponses } from "@tfg/types/endpoints/traceability"

import { CustomFieldValue } from "~/pages/SupplierPortal/TraceabilityRequests/components/CustomFieldInput"
import { useInformationRequestContext } from "~/pages/SupplierPortal/TraceabilityRequests/store/InformationRequestContext"
import { OperationItem } from "~/pages/SupplierPortal/TraceabilityRequests/utils"

export function useCustomFieldInitialValue(
  cfd: TraceabilityResponses.PublicCustomFieldDef,
  operationItem: OperationItem
): CustomFieldValue {
  const { customFieldValues } = useInformationRequestContext()
  return useMemo(() => {
    const customFieldValue = customFieldValues
      .filter((cfv) => cfv.operationId === operationItem.operation?.id)
      .find((x) => x.customFieldDefinitionId === cfd.id)

    if (!customFieldValue) {
      return {
        id: "",
        value: "",
        document: null,
        selectedFile: null,
        customFieldDefinitionId: cfd.id,
        operationId: operationItem.operation?.id ?? 0,
      }
    }

    const rawInitialValue: string = customFieldValue.value

    return {
      id: customFieldValue.id,
      value: rawInitialValue,
      document: customFieldValue.document,
      selectedFile: null,
      customFieldDefinitionId: cfd.id,
      operationId: operationItem.operation?.id ?? 0,
    }
  }, [cfd.id, customFieldValues, operationItem])
}
